import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    LIGHTGRAY_HEADER_CLASS,
    GREY_HEADER_CLASS,
} from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/gridHelpers';
import { GRID_DEFAULT_HEIGHT } from './constants';

// NOTE: be aware that changing this styled component will affect EVERY grid in
// HR module
export const StyGridContainer = styled(Box, {
    name: 'StyGridContainer',
})(({ theme }) => ({
    minHeight: GRID_DEFAULT_HEIGHT,
    '&&& .ag-root-wrapper': {
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: '4px',
    },
    '&&& div.ag-layout-auto-height .ag-center-cols-container': {
        minHeight: '15rem',
    },
    '&&& div.ag-header-row-column-group': {
        height: '0%',
    },
    '&&& .ag-cell': {
        display: 'flex',
        alignItems: 'center',
        fontSize: '11px',
        borderRight: '1px solid lightgray !important',
    },
    // set header text color to darkGrey + avoid default capitalize
    '&&& .ag-header-cell-text': {
        textTransform: 'unset !important',
        color: `${theme.palette.darkGrey} !important`,
    },
    // center the row group header texts
    '.ag-header-group-cell > .ag-header-cell-comp-wrapper': {
        justifyContent: 'center',
    },
    // add border to differentiate row groups
    '&&&  .ag-header-group-cell-with-group, .ag-header-cell': {
        borderLeft: '1px solid lightgray !important',
    },
    // set row group header text color to darkGrey + avoid default capitalize
    '&&& .ag-header-group-text': {
        textTransform: 'unset !important',
        textAlign: 'center',
        color: `${theme.palette.darkGrey} !important`,
    },
    // Allows to give a disabled style to the grid
    [`&&& .${LIGHTGRAY_HEADER_CLASS} .ag-header-group-text`]: {
        color: 'lightgray !important',
    },
    [`&&& .${LIGHTGRAY_HEADER_CLASS} .ag-header-cell-text`]: {
        color: 'lightgray !important',
    },
    // size the paging bottom panel
    '&&& .ag-paging-panel': {
        height: '2rem !important',
    },
    // Allows to give a disabled style to the grid
    [`&&& .${GREY_HEADER_CLASS} .ag-header-group-text`]: {
        color: 'grey !important',
    },
    [`&&& .${GREY_HEADER_CLASS} .ag-header-cell-text`]: {
        color: 'grey !important',
    },
    '&&& .ag-floating-filter .MuiTextField-root': {
        width: '100%',
    },
}));

// NOTE : this grid is used for payComponents and non recurrent envelope grid in the resume section
export const StyNoSpacingGridContainer = styled(StyGridContainer)(() => ({
    minHeight: '300px',
    '&&& div.ag-layout-auto-height .ag-center-cols-container': {
        minHeight: '8rem',
    },
}));
